import React from 'react'
import Header from '../Includes/Header'
import Footer from '../Includes/Footer'
import "./About.css"
import img1 from "../Includes/Images/Kid.webp"
import img2 from "../Includes/Images/Getty.webp"
import img3 from "../Includes/Images/business-whole-home-wifi.webp"
import img4 from "../Includes/Images/wholehome.webp"

function About() {
  return (
    <>
    <Header/>
    <div className="about-container">
      {/* Header Section */}
      <div className="about-header">
        <h1 className="about-title">About Symzitech Solutions</h1>
        <p className="about-tagline">Now you can do it all, wherever you live</p>
        
        <div className="about-section">
          <h2 className="section-title">Who We Are</h2>
          <p className="section-text">
            You can count on Hughesnet®, Hughes Network System's satellite internet service that connects millions of people across the Americas. Hughes Network Systems has been in the satellite business for more than 50 years. We pioneered satellite internet and we've brought high-speed connections to people across America.
          </p>
          <p className="section-text">
            High-speed satellite internet is specifically designed for people who live in parts of the country that lack other connectivity options. Hughes is the trusted leader in satellite internet and invented the technology that allows Symzitech Solutions to bring high-speed satellite connections to consumers and small businesses — regardless of where they are located.
          </p>
        </div>
      </div>

      {/* Why Choose Section */}
      <div className="about-section">
        <h2 className="why-choose-header">Why Choose Symzitech Solutions?</h2>
        
        {/* Faster Speeds */}
        <div className="feature-container">
          <img src={img1} alt="Child using laptop" className="feature-image" />
          <div className="feature-content">
            <h3 className="feature-title">Faster Speeds</h3>
            <p className="feature-text">
              Symzitech Solutions is faster than ever, with download speeds up to 100 Mbps*. With high-speed satellite internet, now you can do it all online, no matter where you live. Stay connected, stream movies, and play your favorite online games.
            </p>
          </div>
        </div>
        
        {/* Unlimited Data */}
        <div className="feature-container reverse">
          <img src={img2} alt="Mother and daughter using laptop" className="feature-image" />
          <div className="feature-content">
            <h3 className="feature-title">Unlimited Data</h3>
            <p className="feature-text">
              With Symzitech Solutions you get unlimited Standard Data** If you use all your Priority Data, Standard Data kicks in automatically. There's no limit on how much Standard Data you can use, so you'll never get cut off or pay overage fees.
            </p>
          </div>
        </div>
        
        {/* Reduced Latency */}
        <div className="feature-container">
          <img src={img3} alt="Man on video call" className="feature-image" />
          <div className="feature-content">
            <h3 className="feature-title">Reduced Latency</h3>
            <p className="feature-text">
              Symzitech Solutions Fusion® plans combine satellite and wireless technologies to reduce latency and deliver a faster, more responsive internet experience.
            </p>
            <p className="feature-text">
              Innovative multipath technology automatically selects the best path for your internet activities - satellite or wireless - in real time, to reduce delays and deliver a faster, more reliable experience. Symzitech Solutions Fusion plans work even if the wireless signal in your area isn't very strong. Search your address to check for availability.
            </p>
            {/* <button className="orange-button">
              Learn More About Fusion
            </button> */}
          </div>
        </div>
        
        {/* Whole Home Wi-Fi */}
        <div className="feature-container reverse">
          <img src={img4} alt="House with Wi-Fi coverage" className="feature-image" />
          <div className="feature-content">
            <h3 className="feature-title">Whole Home Wi-Fi</h3>
            <p className="feature-text">
              All plans include a Wi-Fi Modem featuring Wi-Fi 6 technology. The advanced, built-in Wi-Fi delivers improved speed with enhanced security and better performance for multiple devices.
            </p>
            <p className="feature-text">
              For homes that need more coverage, Whole Home Wi-Fi eliminates dead zones. Simply add up to 3 optional Mesh Wi-Fi Nodes to extend your modem's signal throughout your home, for wall-to-wall Wi-Fi coverage.
            </p>
            {/* <button className="orange-button">
              Learn More
            </button> */}
          </div>
        </div>
      </div>

      {/* Learn More Section */}
      <div className="about-section">
        <h2 className="learn-more-header">Learn More About Symzitech Solutions</h2>
        
        <div className="cards-container">
          {/* FAQ */}
          <div className="info-card">
            <div className="card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-1-5h2v2h-2v-2zm2-1.645V14h-2v-1.5a1 1 0 011-1 1.5 1.5 0 10-1.471-1.794l-1.962-.393A3.5 3.5 0 1113 13.355z" />
              </svg>
            </div>
            <h3 className="card-title">Frequently Asked Questions</h3>
            <p className="card-text">Find answers to common questions about satellite internet and Symzitech Solutions service</p>
            <a href="#" className="blue-link">
              Explore
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
          
          {/* Buyer's Guide */}
          <div className="info-card">
            <div className="card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M21 4H3a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V5a1 1 0 00-1-1zm-1 14H4V6h16v12zM8 10h8v2H8v-2zm0 4h8v2H8v-2z" />
              </svg>
            </div>
            <h3 className="card-title">Buyer's Guide</h3>
            <p className="card-text">Find our which Symzitech Solutions plan is right for you</p>
            <a href="#" className="blue-link">
              Learn More
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
          
          {/* Blog */}
          <div className="info-card">
            <div className="card-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 22H4a1 1 0 01-1-1V3a1 1 0 011-1h16a1 1 0 011 1v18a1 1 0 01-1 1zM7 6v2h10V6H7zm0 4v2h10v-2H7zm0 4v2h7v-2H7z" />
              </svg>
            </div>
            <h3 className="card-title">Blog</h3>
            <p className="card-text">Check out the latest tech and satellite internet news</p>
            <a href="#" className="blue-link">
              Read More
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
        
        {/* Bottom Icons */}
        <div className="cards-container">
          {/* Coverage */}
          <div className="info-card">
            <div className="bottom-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.671 14.307C16.184 12.819 14.17 12 12 12s-4.184.819-5.671 2.307l1.414 1.414C8.964 14.5 10.432 14 12 14s3.036.5 4.257 1.721l1.414-1.414z" />
                <path d="M20.437 11.293c-4.572-4.574-12.301-4.574-16.873 0l1.414 1.414c3.807-3.807 10.238-3.807 14.045 0l1.414-1.414z" />
                <path d="M12 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" />
              </svg>
            </div>
            <h3 className="card-title">Coverage</h3>
            <p className="card-text">Symzitech Solutions is available where you live even in places that are beyond the reach of cable and fiber</p>
            <a href="#" className="blue-link">
              See Coverage
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
          
          {/* 4-H Sponsorship */}
          <div className="info-card">
            <div className="bottom-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 11a4 4 0 110-8 4 4 0 010 8zm0 2c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" />
              </svg>
            </div>
            <h3 className="card-title">4-H Sponsorship</h3>
            <p className="card-text">Symzitech Solutions is proud to be a long-time supporter of 4-H</p>
            <a href="#" className="blue-link">
              Learn More
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
          
          {/* How it Works */}
          <div className="info-card">
            <div className="bottom-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
                <path d="M13 7h-2v6h6v-2h-4z" />
              </svg>
            </div>
            <h3 className="card-title">How it Works</h3>
            <p className="card-text">The technology behind the service.</p>
            <a href="#" className="blue-link">
              Learn more
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  )
}

export default About